import { graphAxis, GraphData } from "./Graph";


export interface FunctionData {

}

export function getFunctionData(modal){
    const functions = getFunctions(modal);
    const integral = modal.find("#integral").is(":checked");
    const grid = modal.find("#gitter").is(":checked");
    const xAxis = getAxisData('x')
    const yAxis = getAxisData('y');

    return {
        functions: functions,
        integral: integral,
        grid: grid,
        xAxis: xAxis,
        yAxis: yAxis,
    }
}

function getAxisData(axis = 'x'):graphAxis{
    let label = $("." + axis + "-label").val().toString()
    if (label == ""){
        label = axis; 
    }

    const lowerBoundary = Number($("." + axis + "-start").val())
    const upperBoundary = Number($("." + axis + "-end").val());

    let domain:Array<number> = [-10, 10];

    if (lowerBoundary !== NaN && upperBoundary !== NaN){
        domain = [lowerBoundary, upperBoundary];
    }

    return {
        label: label,
        domain: domain
    }
}

function getFunctions(modal){
    const funcs = modal.find("input.function");
    const functions = [];
    funcs.each((ind, obj) => {
        const fn = $(obj).val();
        if (fn != ''){
            functions.push({
                fn: $(obj).val()
            })
        }
    });
    return functions;
}

export function renderCurrentFunction(){
    const data = getFunctionData($("#create-graph"))
    plotFunction(data);
}

export function plotFunction(data:GraphData, target="#plotted-function"){
    const functionData = {
        disableZoom: true, // disabled zoom
        target: target,
        // width: data.width,
        // height: data.height,
        yAxis: data.yAxis,
        xAxis: data.xAxis,
        data: data.functions
    }

    if (data.width !== undefined){
        functionData["width"] = data.width;
    }
    if (data.height !== undefined){
        functionData["height"] = data.height;
    }

    
    
    if (data.functions.length > 0){
        if (data.integral){
            functionData.data[0]["closed"] = true;
        }

        if (data.grid){
            functionData["grid"] = true;
        }
    }

    try {
        $(".function-error").hide();
        functionPlot(functionData);
    } catch (e) {
        // errorToast("Der Graph konnte nicht geladen werden, bitte bearbeite ihn und speichere erneut.")
        $(".function-error").show();
    }
}